import React, {useCallback} from "react";
import styles from "./Tag.module.css";
import {VideoTag} from "../../video/models/VideoTag";

interface TagProps {
    tag: VideoTag;
    onClick?: (tag: VideoTag) => void;
}

function Tag({tag, onClick}: TagProps) {
    const handleClick = useCallback(() => {
        if (onClick) {
            onClick(tag);
        }
    }, [onClick, tag]);

    return (
        <div className={styles.tag} onClick={handleClick}>
            {tag}
        </div>
    );
}

export default Tag;
